import { Component, input, InputSignal, output } from '@angular/core';

import { Content } from '../types';

@Component({
  selector: 'glxy-transcript-contents',
  standalone: true,
  imports: [],
  templateUrl: './transcript-contents.component.html',
  styleUrls: ['./transcript-contents.component.scss'],
})
export class TranscriptContentsComponent {
  contents: InputSignal<Content[]> = input.required<Content[]>();
  readonly contentClicked = output<Content>();

  textClicked(content: Content): void {
    this.contentClicked.emit({
      ...content,
    });
  }
}
